import { PaginationState, SortingState } from '@tanstack/react-table';
import { z } from 'zod';

export const PolicyTransactionSchema = z.object({
	id: z.number(),
	fileIngestionId: z.number(),
	policyNumber: z.string().nullable(),
	policyId: z.number().nullable(),
	transSummaryId: z.number().nullable().optional(),
	transactionDate: z.string().refine((val) => !isNaN(Date.parse(val))),
	riskState: z.string(),
	premium: z.number(),
	slTax: z.number(),
	policyFee: z.number(),
	inspectionFee: z.number().nullable().optional(),
	retainedPremium: z.number(),
	status: z.string(),
	userNotes: z.string().nullable().optional(),
	agent: z.string().nullable().optional(),
	notes: z.string().nullable().optional(),
});

export type PolicyTransaction = z.infer<typeof PolicyTransactionSchema>;

export const all = async (
	pagination: PaginationState,
	sorting: SortingState = [],
	params: object,
): Promise<{ data: PolicyTransaction[]; total: number }> => {
	try {
		let queryString = '';
		if (params) {
			const paramsAsString = JSON.stringify(params)
				.replace(/:/g, '=')
				.replace(/,/g, '&')
				.replace(/[{}"]/g, '');

			const searchParams = new URLSearchParams(paramsAsString);
			if (pagination) {
				searchParams.append('pageSize', pagination.pageSize.toString());
				searchParams.append('pageIndex', pagination.pageIndex.toString());
			}
			
			if (sorting.length > 0) {
				searchParams.append('sortBy', sorting[0].id);
				searchParams.append('sortDirection', sorting[0].desc ? 'desc' : 'asc');
			}

			queryString = `?${searchParams.toString()}`;
		}

		const response = await fetch(`/GeoveraTransactions${queryString}`);

		return await response.json();
	} catch (err) {
		return {
			data: [],
			total: 0,
		};
	}
};

export const update = async (
	policyTransaction: PolicyTransaction,
): Promise<boolean> => {
	const res = await fetch(`/GeoveraTransactions`, {
		method: 'PATCH',
		body: JSON.stringify(policyTransaction),
		headers: {
			'Content-Type': 'application/json',
		},
	});
	return res.ok;
};

export const downloadPolicies = async (
	fileIngestionId: number,
): Promise<Blob> => {
	const response = await fetch(
		`/GeoveraTransactions/download/${fileIngestionId}`,
		{
			method: 'GET',
		},
	);

	return await response.blob();
};
